import axios from "axios";
import { forceClientLogout } from "@/lib/auth/forceClientLogout";
import { captureApiError } from "./capture-api-error";

/** Same-origin BFF — attaches Bearer from httpOnly cookies and refreshes server-side. */
export const clientApi = axios.create({
  baseURL: "/api/proxy",
  withCredentials: true,
});

clientApi.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    config.headers = {
      ...config.headers,
      "X-Origin-Domain": window.location.host,
    };
  }

  return config;
});

function isPublicAuthRequest(error) {
  const url = String(error?.config?.url || "");
  return (
    url.includes("/c/auth/otp") ||
    url.includes("/c/auth/verify") ||
    url.includes("/public/auth")
  );
}

clientApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    captureApiError(error);

    if (error.response?.status === 401 && !isPublicAuthRequest(error)) {
      // BFF already cleared cookies on session death; sync client and navigate once.
      forceClientLogout();
    }
    throw error;
  },
);
